import * as React from 'react'
import type { LucideProps } from 'lucide-react'

// Lucide has no football: `Goal` is a corner flag, `Volleyball` the wrong ball. Drawn to
// lucide's grid and forwarding a ref, so it is an `IconComponent` like the rest of the set.
export const IconGoalPost = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      fill="none"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2 16V6h20v10" />
      <path d="M6 16V9h12v7" />
      <path d="M10 9v7M14 9v7M6 12.5h12" />
      <circle cx="12" cy="19.5" r="2.5" />
    </svg>
  ),
)
IconGoalPost.displayName = 'IconGoalPost'
